import type { flightEntity } from 'freedom-shared';

import { flightConnectionLib } from './lib';

export const getFlightConnectionData = (
  segment: flightEntity.types.MappedSegment,
  nextSegment: flightEntity.types.MappedSegment,
) => {
  const connectionDuration = flightConnectionLib.connectionDuration(segment);
  const hasGuarantorAirline = segment.connection?.guarantor === 'airline';
  const isSelfTransfer = flightConnectionLib.isSelfTransfer(segment);
  const hasNextDayDep = flightConnectionLib.hasNextDayDep(segment);
  const isRecheckRequired = segment.baggage.recheck_required === true;
  const hasDifferentAirport = segment.arr.airport !== nextSegment.dep.airport;
  const hasDifferentTerminal = hasDifferentAirport
    ? false
    : segment.arr.terminal !== nextSegment.dep.terminal;
  const isSelfMovingBaggage =
    isSelfTransfer && (hasDifferentAirport || hasDifferentTerminal);

  return {
    connectionDuration,
    hasGuarantorAirline,
    hasNextDayDep,
    isRecheckRequired,
    isSelfMovingBaggage,
    isSelfTransfer,
    hasDifferentAirport,
    hasDifferentTerminal,
  };
};
